import {
    DataArray,
    UpdateIconButton,
    pn,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@compass/core";
import { ListBeProperty } from "components";
import { DisciplineListResource, DisciplineListDto, Permission, PermissionAction, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { disciplinePageRoute } from "../DisciplinePage/DisciplinePage";

export const DisciplineTable = (props: {
    rootPermission: Permission;
    tableContainerRef: React.RefObject<HTMLDivElement>;
    disciplines: DisciplineListDto[];
    setDisciplines: (disciplines: DisciplineListDto[]) => void;
    resource: DisciplineListResource;
    searchFocused: boolean;
    sortObjects: SortObject[] | undefined;
    sort: (sortObjects: SortObject[]) => void;
    loadList: () => void;
}) => {
    const navigate = useNavigate();
    const properties = props.resource.properties || [];

    return (
        <TableContainer ref={props.tableContainerRef}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "7%"}}>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<DisciplineListDto>("id"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<DisciplineListDto>("name"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.disciplines.map((discipline) => (
                        <TableRow
                            key={discipline.id}
                            onClick={() =>
                                navigate(
                                    disciplinePageRoute.getPath({
                                        id: discipline.id,
                                        crudMode: "view",
                                        screenType: "dialog"
                                    })
                                )
                            }
                        >
                            <TableCell>{discipline.id}</TableCell>
                            <TableCell>{discipline.name}</TableCell>
                            <TableCell type="action">
                                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                                    <UpdateIconButton color="primary"
                                        onClick={() =>
                                            navigate(
                                                disciplinePageRoute.getPath({
                                                    id: discipline.id,
                                                    crudMode: "edit",
                                                    screenType: "dialog"
                                                })
                                            )
                                        }
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};